import { NgModule } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { SharedModule } from '@shared/index';
import { CommonComponent } from './common/common.component';

@NgModule({
  imports: [
    SharedModule
  ],
  exports: [
    HeaderComponent
  ],
  declarations: [
    HeaderComponent,
    CommonComponent
  ],
  providers: []
})
export class LayoutModule { }
